import { render, staticRenderFns } from "./about_recruit.vue?vue&type=template&id=44f7e9b1&scoped=true&"
import script from "./about_recruit.vue?vue&type=script&lang=js&"
export * from "./about_recruit.vue?vue&type=script&lang=js&"
import style0 from "./about_recruit.vue?vue&type=style&index=0&id=44f7e9b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f7e9b1",
  null
  
)

export default component.exports